import React from 'react';
import { getRouteUrl } from '@css-xp/ppc-utils';
import { routePaths } from '@css-xp/ppc-constants';
import { CloudSiteWidgetItem } from '../../widget';
import { Maybe } from '@css-xp/graphtypes/src/generated-types-new';
import { CloudSiteForWidget } from './types';

type CloudSites = Maybe<Array<CloudSiteForWidget>> | undefined;

export const getRecentlyViewedCloudSiteWidgetContent = (cloudSites: CloudSites, heading?: string, version?: number) => {
  if (!cloudSites || !cloudSites.length) {
    return null;
  }

  return cloudSites.map((cloudSite, index) => {
    if (!cloudSite) {
      return null;
    }
    const URL = getRouteUrl(routePaths.cloudSite, {
      txaId: cloudSite.transactionAccountId,
      cloudSiteId: cloudSite.cloudSiteId as string,
    });
    return <CloudSiteWidgetItem url={URL} key={index} {...cloudSite} heading={heading} version={version} />;
  });
};
